import React from 'react';
import { FiMail, FiPhone, FiMapPin, FiClock } from 'react-icons/fi';

const ContactPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-24 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4 font-poppins">
            Contact Us
          </h1>
          <div className="w-24 h-1 mx-auto" style={{ backgroundColor: '#4CAF50' }}></div>
          <p className="mt-6 text-xl text-gray-600 max-w-3xl mx-auto font-poppins">
            We're here to help and answer any questions you might have.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Contact Information */}
          <div className="space-y-6">
            {/* Email */}
            <div className="group relative bg-white rounded-xl p-8 transition-all duration-300 hover:shadow-lg border border-gray-200 hover:border-green-300">
              <div className="flex items-start space-x-6">
                <div className="flex-shrink-0 p-4 rounded-lg" style={{ backgroundColor: 'rgba(76, 175, 80, 0.1)', color: '#4CAF50' }}>
                  <FiMail className="w-8 h-8" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2 font-poppins">Email Us</h3>
                  <p className="text-gray-600 font-poppins">
                    <a 
                      href="mailto:admin@himanshusalarycorner.in" 
                      className="hover:text-green-600 transition-colors duration-200"
                      style={{ color: 'inherit', textDecoration: 'none' }}
                    >
                      admin@himanshusalarycorner.in
                    </a>
                  </p>
                  <p className="mt-2 text-gray-500 text-sm font-poppins">
                    Typically respond within 24 hours
                  </p>
                </div>
              </div>
            </div>

            {/* Phone */}
            <div className="group relative bg-white rounded-xl p-8 transition-all duration-300 hover:shadow-lg border border-gray-200 hover:border-green-300">
              <div className="flex items-start space-x-6">
                <div className="flex-shrink-0 p-4 rounded-lg" style={{ backgroundColor: 'rgba(76, 175, 80, 0.1)', color: '#4CAF50' }}>
                  <FiPhone className="w-8 h-8" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2 font-poppins">Call Us</h3>
                  <p className="text-gray-600 font-poppins">
                    <a 
                      href="tel:+919529402894" 
                      className="hover:text-green-600 transition-colors duration-200"
                      style={{ color: 'inherit', textDecoration: 'none' }}
                    >
                      +91 9529402894
                    </a>
                  </p>
                  <p className="mt-2 text-gray-500 text-sm font-poppins">
                    Monday - Saturday, 9AM to 6PM
                  </p>
                </div>
              </div>
            </div>

            {/* Location */}
            <div className="group relative bg-white rounded-xl p-8 transition-all duration-300 hover:shadow-lg border border-gray-200 hover:border-green-300">
              <div className="flex items-start space-x-6">
                <div className="flex-shrink-0 p-4 rounded-lg" style={{ backgroundColor: 'rgba(76, 175, 80, 0.1)', color: '#4CAF50' }}>
                  <FiMapPin className="w-8 h-8" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2 font-poppins">Our Office</h3>
                  <address className="not-italic text-gray-600 font-poppins">
                    159, Guruwar Peth, Opp. Shahu Garden, Satara, Maharashtra 415002
                  </address>
                  <p className="mt-2 text-gray-500 text-sm font-poppins">
                    Visit us by appointment
                  </p>
                </div>
              </div>
            </div>

            {/* Hours */}
            <div className="group relative bg-white rounded-xl p-8 transition-all duration-300 hover:shadow-lg border border-gray-200 hover:border-green-300">
              <div className="flex items-start space-x-6">
                <div className="flex-shrink-0 p-4 rounded-lg" style={{ backgroundColor: 'rgba(76, 175, 80, 0.1)', color: '#4CAF50' }}>
                  <FiClock className="w-8 h-8" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2 font-poppins">Business Hours</h3>
                  <ul className="space-y-1 text-gray-600 font-poppins">
                    <li className="flex justify-between">
                      <span>Monday - Friday</span>
                      <span>9:00 AM - 6:00 PM</span>
                    </li>
                    <li className="flex justify-between">
                      <span>Saturday</span>
                      <span>9:00 AM - 4:00 PM</span>
                    </li>
                    <li className="flex justify-between text-gray-500">
                      <span>Sunday</span>
                      <span>Closed</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* Map and Contact Form */}
          <div className="space-y-8">
            {/* Map */}
            <div className="bg-white rounded-xl overflow-hidden border border-gray-200 h-full min-h-[400px] shadow-sm hover:shadow-md transition duration-300">
              <iframe
                className="w-full h-full"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3801.376010397325!2d73.9951004!3d17.679688799999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc23933fdb8ff11%3A0xb2b9276e903e0ca8!2sHimanshu%20Salary%20Corner!5e0!3m2!1sen!2sin!4v1737573244299!5m2!1sen!2sin"
                style={{ border: '0' }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Location on Google Maps"
              />
            </div>

            {/* Contact Form */}
            {/* <div className="bg-white rounded-xl p-8 border border-gray-200 shadow-sm hover:shadow-md transition duration-300">
              <h3 className="text-2xl font-semibold text-gray-900 mb-6 font-poppins">Send Us a Message</h3>
              <form className="space-y-6">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1 font-poppins">
                    Full Name
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent text-gray-900 placeholder-gray-400 transition duration-200 font-poppins"
                    style={{ '--tw-ring-color': '#4CAF50' }}
                    placeholder="Your name"
                  />
                </div>
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1 font-poppins">
                    Email Address
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent text-gray-900 placeholder-gray-400 transition duration-200 font-poppins"
                    style={{ '--tw-ring-color': '#4CAF50' }}
                    placeholder="your.email@example.com"
                  />
                </div>
                <div>
                  <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1 font-poppins">
                    Your Message
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    rows="4"
                    className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-lg focus:ring-2 focus:border-transparent text-gray-900 placeholder-gray-400 transition duration-200 font-poppins"
                    style={{ '--tw-ring-color': '#4CAF50' }}
                    placeholder="How can we help you?"
                  ></textarea>
                </div>
                <button
                  type="submit"
                  className="w-full font-medium py-3 px-6 rounded-lg transition-all duration-300 shadow hover:shadow-lg font-poppins"
                  style={{ backgroundColor: '#4CAF50', color: 'white' }}
                >
                  Send Message
                </button>
              </form>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;